module.exports = __webpack_public_path__ + "img/popcorn.e54ede62.svg";